import { Swiper, Navigation, Pagination, Autoplay, EffectFade, Keyboard } from 'swiper/dist/js/swiper.esm.js'

function init() {
  jQuery(function($) {
    Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Keyboard])

    // initialize swiper when document ready
    const swiperElem = $('.palaute-slider-block .swiper-container')
    if (swiperElem.length === 0) {
      return
    }
    let loopVal = false
    if ($(swiperElem).find('.swiper-slide').length > 1) {
      // loop only if swiper has more than 1 slide
      loopVal = true
    }
    const swiper = new Swiper(swiperElem, {
      /* fadeEffect: {
        crossFade: true
      },
      effect: 'fade', */
      speed: 500,
      loop: loopVal,
      watchOverflow: true,
      autoHeight: false,
      centeredSlides: true,
      /* autoplay: {
        delay: 5000,
        disableOnInteraction: true
      }, */
      pagination: {
        el: $(swiperElem).find('.swiper-pagination'),
        clickable: true
      },
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: $(swiperElem).siblings('.swiper-button-next'),
        prevEl: $(swiperElem).siblings('.swiper-button-prev')
      }
    })
    swiper.init()
  })

}

export default {
  init
}